<template>
	<el-main class='posR' id='layoutMain'>
		<transition name='fade' mode='out-in'>
			<keep-alive :include='pages'>
				<router-view></router-view>
			</keep-alive>
		</transition>
	</el-main>
</template>

<script scoped>
	import { mapGetters } from "vuex"
	export default {
		name: 'page',
		computed: {
		    ...mapGetters('tabs', {
				TABLIST: 'tabList'
		    }),
		    /*缓存标签页内的页面*/
		    pages() {
		    	let pages = []
		    	for(let i = 0; i < this.TABLIST.length; i++){
		    		pages[i] = this.TABLIST[i].code
		    	}
		    	return pages
		    }
		}
	};
</script>


// WEBPACK FOOTER //
// src/views/layout/components/Page.vue